import _tmpl from "./chip.html";
import { LightningElement, registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import { c as classNames } from "ax/chunk_index";
let Size = /*#__PURE__*/function (Size) {
  Size["Default"] = "default";
  Size["Small"] = "small";
  return Size;
}({});
class Chip extends LightningElement {
  constructor(...args) {
    super(...args);
    this.ariaLabel = null;
    this.ariaLive = null;
    this.size = Size.Default;
    this.text = void 0;
  }
  get classes() {
    return classNames("element", {
      [`size-${this.size}`]: this.size !== "default" && Object.values(Size).includes(this.size)
    });
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Chip, {
  publicProps: {
    ariaLabel: {
      config: 0
    },
    ariaLive: {
      config: 0
    },
    size: {
      config: 0
    },
    text: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(Chip, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;